module.exports = __webpack_public_path__ + "img/logoFinalMK.c0a813d3.png";